export default [
    {
    	path:'jump/:caseId',
    	component(resolve) {
            require(['@/components/student/group-current/jump'], resolve)
        },
        meta: {  
            title : '小组首页'
        }
    },
    {
    	path:'list/:caseId',
    	component(resolve) {
            require(['@/components/student/group/list'], resolve)
        },
        meta: {  
            title : '小组列表'
        }
    },
    {
    	path:'index/:groupId/:caseId',
    	component(resolve) {
            require(['@/components/student/group/index'], resolve)
        },
        meta: {  
            title : '我的小组'
        }
    },
    {
    	path:'vote/result/:caseId/:groupId',
    	component(resolve) {
            require(['@/components/student/group/vote-result'], resolve)
        },
        meta: {  
            title : '投票结果'
        }
    },
    {
    	path:'vote/:caseId/:groupId/:canQuit',
    	component(resolve) {
            require(['@/components/student/group/vote'], resolve)
        },
        meta: {  
            title : '选择组长'
        }
    },
    {
    	path:'face/:caseId',
    	component(resolve) {
            require(['@/components/student/group-current/face'], resolve)
        },
        meta: {  
            title : '面对面建组'
        }
    },
    {
        path:'res/board/:coursewareFileId',
        component(resolve) {
            require(['@/components/student/group-current/board'], resolve)
        },
        meta: {  
            title : '白板板书'
        }
    }
]




// WEBPACK FOOTER //
// ./src/router/student/group-current.js